// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdaptiveSelect_wrapper_1sxLc","label":"AdaptiveSelect_label_1Ii9O","isPlaceholderValue":"AdaptiveSelect_isPlaceholderValue_1JeMj","select":"AdaptiveSelect_select_165U8"};